import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// add authorization header with jwt token if available
		let User = JSON.parse(localStorage.getItem('User'));
		if (User && User.token) {
			request = request.clone({
				setHeaders: { 
					Authorization: `Bearer ${User.token}`
				}
			});
		}

		return next.handle(request);
	}
}